import styled from "styled-components";
import { Backdrop } from "@material-ui/core";

const CustomBackdrop = styled(Backdrop)`
  &&& {
    background: ${({ theme }) => theme.palette.secondary.dark};
    opacity: 0.6 !important;
  }
`;

export default CustomBackdrop;
